import RemoteData from "./RemoteData";

class RemoteCollection extends RemoteData {
  constructor(url) {
    super(url);

    // Initial states ...
    this.transformer = null;
    this.data = [];
  }

  whenLoaded(data) {
    data.data.forEach(item => {
      if (this.transformer) {
        this.transformer(item);
      }
    });

    return super.whenLoaded(data);
  }

  transform(transformer) {
    this.transformer = transformer;
    return this;
  }

  filter(value, clear = false) {
    if (clear) {
      this.withParams = {};
    }

    for (let field in value) {
      this.withParams["filter[" + field + "]"] = value[field];
    }

    return this;
  }

  sort(field, direction) {
    let value = direction === "desc" ? `-${field}` : field;

    this.with({ sort: value }).load();

    return this;
  }

  take(pageSize) {
    this.withParams["page[size]"] = pageSize;

    return this;
  }

  removeAt(index) {
    this.data.splice(index, 1);
  }
}

export default RemoteCollection;
